import { IProgram } from "../../../../domain/core/entities/programEntity";
import IProgramFailure from "../../../../domain/core/failures/program/programFailure";

export interface IProgramsListStates {
  getProgramsState: IGetProgramsState;
  deleteProgramState: IDeleteProgramState;
  editProgramStatusState: IEditProgramStatusState;
}

interface IGetProgramsState {
  data: IProgram[];
  loading: boolean;
  sucessful: boolean;
  error: IProgramFailure | null;
  limit: number;
}

interface IDeleteProgramState {
  data: string | null;
  loading: boolean;
  sucessful: boolean;
  error: IProgramFailure | null;
}

interface IEditProgramStatusState {
  data: string | null;
  loading: boolean;
  sucessful: boolean;
  error: IProgramFailure | null;
}

export const initialState = {
  getProgramsState: {
    data: [],
    loading: false,
    sucessful: false,
    error: null,
    limit: 10,
  },
  deleteProgramState: {
    data: null,
    loading: false,
    sucessful: false,
    error: null,
  },
  editProgramStatusState: {
    data: null,
    loading: false,
    sucessful: false,
    error: null,
  },
};
